import { useApplicationContext } from '../../../utils/applicationContext';

export const useCianMortgageUrl = () => {
  const { config } = useApplicationContext();

  return (
    config.get<string>('newbuilding-promos-frontend.cianMortgageUrl') ??
    '/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mortgage_banner&cian_content=skidki_i_akcii_mortgage_percents'
  );
};
